import React from 'react'
// import { I18n } from 'react-i18next'

const VCCustomContact = ({day, month, year, body, t}) => (
  // <I18n>
  //   {
  //     t => (
        <div className="grid gridContainerCustom">
          <div className="gitem">
            <div className="row">
              <div className="col gitemColumn">
                <div>
                  <span className="day">{day}</span>
                  <span className="month">{month}</span>
                  <span className="year">{year}</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col gitemColumn">
                <div>{body}</div>
              </div>
            </div>
            <div className="row">
              <div className="col gitemColumn">
                <div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
  //     )
  //   }
  // </I18n>
)

export default VCCustomContact


// WEBPACK FOOTER //
// ./src/custom/components/VCCustomEvents.js